<template>
  <input v-model="value" type="number" min="0" step="0.1" :title="hint"
    :class="stopedUpdate ? 'input_color-update' : ''" :readonly="$store.getters.editMode" :style="getStyle()" />
</template>

<script>
import MixinStates from "./mixin-states.js";
import EventBus from "@/core/EventBus";
export default {
  name: "input_",
  mixins: [MixinStates],
  data() {
    return { stopedUpdate: false, inputValue: null };
  },
  mounted() {
    EventBus.on("on-send-variable", (data) => {
      const { componentName, variables } = data;
      if (componentName === this.ident) {
        for (const iterator of Object.keys(variables)) {
          if (this[iterator]) {
            this[iterator] = data[iterator];
          }
        }
      }
    });
    EventBus.on("on-get-variable", (data) => {
      const { componentName, variableName } = data;
      if (componentName === this.ident) {
        if (variableName) {
          this.$store.commit("INPUT_VARIABLE", this[variableName]);
        } else {
          return this.$store.commit("INPUT_VARIABLE", this);
        }
      }
    });
  },
  unmounted() {
    EventBus.off("on-send-variable");
    EventBus.off("on-get-variable");
  },
  computed: {
    value: {
      get() {
        if (!this.stopedUpdate) {
          if (typeof this.properties[this.PropertyURI] == "undefined") {
            return null;
          } else {
            return this.properties[this.PropertyURI].outputValue?.value;
          }
        } else return this.inputValue;
      },
      set(val) {
        this.inputValue = val;
        this.stopedUpdate = true;
        if (typeof this.properties[this.PropertyURI] == "undefined" && this.PropertyURI) {
          this.properties[this.PropertyURI] = { outputValue: { value: val } };
        } else if (this.PropertyURI) {
          this.properties[this.PropertyURI].outputValue.value = val;
        }
        //this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    getStyle() {
      return { 'text-align': 'right', 'z-index': 2, 'font-weight': this.fontStyle }
    }
  }
};
</script>
<style lang="scss" scoped>
input {
  width: 100%;
  height: 100%;
  border-color: #BCBDBD;
  border-width: 1px;
  border-style: groove;
}

.input_color-update {
  background: greenyellow !important;
}

.input_color-gray {
  background: lightslategray;
}

.input_color-l-gray {
  background: #e5e8f5;
}

.input_color-red {
  background: rgb(224, 76, 76);
}

.input_color-yellow {
  background: yellow;
}

.input_color-yellow {
  background: rgb(96, 96, 224);
}
</style>
